export default __webpack_public_path__ + "static/media/calendar.37ac3031.svg";